import { render, staticRenderFns } from "./ProductTxInbound.vue?vue&type=template&id=ad28d214&scoped=true&"
import script from "./ProductTxInbound.vue?vue&type=script&lang=js&"
export * from "./ProductTxInbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad28d214",
  null
  
)

export default component.exports